import React from 'react';
import { Button, Layout } from 'antd';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';

import { UserAddOutlined, UnlockOutlined } from '@ant-design/icons';
// import Settings from "./partials/Settings";
import LogoSrc from '../../assets/images/Abby_3x.png';
import smLogoSrc from '../../assets/images/Abby_3x.png';

const { Header, Content } = Layout;
const items = [
  {
    label: 'Login',
    key: '/login',
    icon: <UnlockOutlined />,
  },
  {
    label: 'Register',
    key: '/register',
    icon: <UserAddOutlined className="ml-2" />,
  },
];

function GuestLayout({ children }) {
  const location = useLocation();

  return (
    <Layout>
      {/*<Sider/>*/}
      <Layout>
        <Header className={`px-2 bg-white shadow-sm relative`}>
          <div className="flex items-center justify-between max-w-7xl mx-auto">
            <div className="demo-logo">
              <Link to={`/${location.search}`} className="hidden sm:inline">
                <img
                  src={LogoSrc}
                  alt="logo"
                  className={classNames(
                    'w-[96px] p-3 invert',
                    // !isDarkMode && "invert"
                  )}
                />
              </Link>
              <Link to={`/${location.search}`} className="inline sm:hidden">
                <img
                  src={smLogoSrc}
                  alt="logo"
                  className={classNames(
                    'w-[96px] p-3 invert',
                    // !isDarkMode && "invert"
                  )}
                />
              </Link>
            </div>
            <div className="flex items-center">
              {items.map((item) => (
                <Link key={item.key} to={item.key + location.search}>
                  <Button type="link" icon={item.icon} className="text-black">
                    {item.label}
                  </Button>
                </Link>
              ))}
              {/* <Menu
                theme="light"
                mode="horizontal"
                items={items}
                defaultSelectedKeys={[location.pathname]}
                onClick={handleClick}
              /> */}
            </div>
          </div>
        </Header>
        <Content
          className={`w-screen flex items-center justify-center px-4 bg-white`}
          style={{ minHeight: 'calc(100vh - 64px)' }}
        >
          {children}
        </Content>
      </Layout>
      {/* <Settings /> */}
    </Layout>
  );
}

export default GuestLayout;
